import SEO from '@/components/seo'
import Terms from '@/views/terms'

const TermsPage = () => (
  <>
    <SEO
      title="利用規約"
      url="terms"
      description="ONLIVE Studio の利用規約です。サービスをご利用いただく前に必ずお読みください。"
    />
    <Terms />
  </>
)

export default TermsPage
